import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  .ant-select,
  .ant-select-selector {
    width: 300px !important;
  }
`;

export const LabelText = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  width: 250px;
`;
